<template>
    <section class="container">
      <div class="route">
        {{$locales.gestionanticipos.gestionanticipos}} > {{$locales.gestionanticipos.simulacionanticipoordenesmarcadas}}
      </div>
      <div class="wide-window">
        <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Operación realizada con éxito</h3>
        </div>
        <div class="mensajeError" v-else-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
        </div>
        <h1>{{$locales.gestionanticipos.simulacionanticipoordenesmarcadas}}</h1>
        <div class="form-group">
          <form class="window-form" @submit.prevent="aceptar">
            <!-- Primer campo -->
            <!-- Cabecera -->
            <label for="fecha">* Fecha</label>
            <!-- Input -->
            <md-datepicker :class = "(submitted && $v.model.fecha.$invalid)?'invalid':''" id="fecha" name="fecha" v-model="model.fecha" md-immediately><label class="insideLabel">Fecha</label></md-datepicker>
            <!-- Posibles errores de validacion -->
            <div class="error" v-if="submitted && !$v.model.fecha.required">Este campo es obligatorio</div>
            <div class="error" v-if="submitted && !$v.model.fecha.differentFromToday">La fecha de solicitud no puede ser anterior a la de hoy</div>

            <div class="AdvancePaymentsButtons">
                <!-- Boton aceptar -->
              <input class="btnPrimary separacion" type="submit" value="Aceptar" v-if=beforeSubmit :disabled="isDisabled">
              <!-- Boton volver -->
              <input class="btnSecondary" type="button" value="Volver" @click="volver">
            </div>
          </form>
          <div class="firmaconSalida" v-if=datosFirma>
            <SignatureComponent :queries="queries" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
          </div>
          <div class="output" v-if="submitted && confirmacion=='OK'">
            <md-table v-model="ordenMarcada">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell><span class="cabeceraVertical">{{ item.label }}</span></md-table-cell>
                <md-table-cell>{{ item.value }} <span v-if="item.moneda">{{ item.moneda }}</span></md-table-cell>
              </md-table-row>
            </md-table>
            <hr/>
            <p id="subTextMarkedOrders">
              El tipo de interés que aparece en la pantalla de solicitud es orientativo. El tipo de Interés definitivamente aplicable será el
              que figure en la correspondiente liquidación que le efectúe Eurocaja Rural, de acuerdo con lo pactado entre el cliente pagador
              y Eurocaja Rural.<br><br><br>
            </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import format from 'date-fns/format';
import SignatureComponent from './SignatureComponent';
import { required } from "vuelidate/lib/validators";
import AdvancePaymentofMarkedOrders from '../models/AdvancePaymentofMarkedOrders';
export default {
    name : 'AdvancePaymentofMarkedOrdersComponent',
    data(){
      return{
        ordenMarcada: new Array(),
        datosSalida:false, //PROVISIONAL, SIMULA LA LISTA DE SALIDA PARA MOSTRARLA CUANDO LLAMEMOS AL SERVICE
        confirmacion:null,
        queries:null,
        firma:false,
        beforeSubmit:true,
        llamada:null,
        datosFirma: null,
        mensajeError:'Algo ha ido mal, asegúrate que has introducido correctamente tus datos', //mensaje de error por defecto
        submitted: false,
        model : new AdvancePaymentofMarkedOrders() //nuestro model contiene los datos de Entrada, es como el modelCriteria de TF
      }
    },
    computed : {
      isDisabled: function() { //aqui pondremos los campos obligatorios de nuestro form
        return  !this.model.fecha;
      }
    },
    validations : { //aqui ponemos la validacion de cada input del html
      model : {
        fecha: {
          required, //esto lo hace obligatorio
          differentFromToday: function() { //validacion personalizada
            if(this.model.fecha!=null){
              if(this.model.fecha.toDateString()==new Date().toDateString() || this.model.fecha>new Date()){
                return true;
              }else{
                return false;
              }
            }
          }
        }
      }
    },
    components: {
      SignatureComponent
    },
    methods: {
      formatearMoneda(coin) {
        if(coin=="EUR") {
          coin = "€"
          return coin;
        }else if(coin=="DOL") {
          coin = "$"
          return coin;
        }
      },
      callBackAceptar(confirmacion, result){
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.datosFirma = null;
        if(confirmacion=='KO'){
          this.mensajeError = result;
        }else if(confirmacion=='OK'){
          this.datosSalida=result.data.data; 
          var gastos=this.datosSalida.totalCommission.amount/*+this.datosSalida.totalIva.amount*/;
          var date = new Date(this.datosSalida.date);
          let dateFormat = 'dd/MM/yyyy';
          this.ordenMarcada= [{label: 'Cuenta de abono',value: this.datosSalida.accountConfirming.formats[0].value},
          {label: 'Fecha solicitud de anticipo',value: format(date, dateFormat)},
          {label: 'N\u00B0 facturas a anticipar',value: this.datosSalida.totalOrders},
          {label: 'Importe facturas',value: this.datosSalida.totalAmount.amount,moneda: this.datosSalida.totalAmount.currency ? this.formatearMoneda(this.datosSalida.totalAmount.currency.id) : ''},
          {label: 'Comisión',value: gastos,moneda: this.datosSalida.totalCommission.currency ? this.formatearMoneda(this.datosSalida.totalCommission.currency.id) : ''},
          {label: 'Intereses',value: this.datosSalida.totalInterest.amount,moneda: this.datosSalida.totalInterest.currency ? this.formatearMoneda(this.datosSalida.totalInterest.currency.id) : ''},
          {label: 'IVA Comisión',value: this.datosSalida.totalIva.amount,moneda: this.datosSalida.totalIva.currency ? this.formatearMoneda(this.datosSalida.totalIva.currency.id) : ''},
          {label: 'Importe neto anticipo',value: this.datosSalida.totalNetAmount.amount,moneda: this.datosSalida.totalNetAmount.currency ? this.formatearMoneda(this.datosSalida.totalNetAmount.currency.id) : ''}];
        }
      },
     callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },
      volver(){
        this.$router.push({ name:'gestionAnticipos', 
          params: { 
            deudor:this.$route.params.deudor, 
            fechaDesde : this.$route.params.fechaDesde, 
            fechaHasta : this.$route.params.fechaHasta, 
            fechaAltaDesde : this.$route.params.fechaAltaDesde, 
            fechaAltaHasta : this.$route.params.fechaAltaHasta, 
            importeDesde : this.$route.params.importeDesde, 
            importeHasta : this.$route.params.importeHasta, 
            deudores : this.$route.params.deudores 
          }
        });
      },
      aceptar() {
        this.submitted = true;
          this.$v.$touch();
          if(this.$v.$invalid) {
            return false;
          }else {
            let dateFormat = 'yyyy-MM-dd';
            
            var fecha=null;
            if(this.model.fecha!=null){
              fecha=format(this.model.fecha, dateFormat);
            }
            var ventana=this;
            const baseURI = '/api-confirming/confirming/suppliers/markedorders/advanceSimulate';
            const options = {
                params: {
                    'deudorId':this.$route.params.deudor,
                    'date':fecha,
                    'userConditions' : 1
                }
              };
              this.llamada = {
                urlEndpoint : baseURI,
                metodo : 'POST'
              };
              this.queries = options.params;
            let loader = this.$loading.show();
            this.$http.post(baseURI,null,options)
            .then((result) => {
              this.datosSalida=result.data.data; 
              var gastos=this.datosSalida.totalCommission.amount;
              var date = new Date(this.datosSalida.date);
              let dateFormat = 'dd/MM/yyyy';
              this.ordenMarcada= [{label: 'Cuenta de abono',value: this.datosSalida.accountConfirming.formats[0].value},
              {label: 'Fecha solicitud de anticipo',value: format(date, dateFormat)},
              {label: 'N\u00B0 facturas a anticipar',value: this.datosSalida.totalOrders},
              {label: 'Importe facturas',value: this.datosSalida.totalAmount.amount,moneda: this.datosSalida.totalAmount.currency ? this.formatearMoneda(this.datosSalida.totalAmount.currency.id) : ''},
              {label: 'Comisión',value: gastos,moneda: this.datosSalida.totalCommission.currency ? this.formatearMoneda(this.datosSalida.totalCommission.currency.id) : ''},
              {label: 'Intereses',value: this.datosSalida.totalInterest.amount,moneda: this.datosSalida.totalInterest.currency ? this.formatearMoneda(this.datosSalida.totalInterest.currency.id) : ''},
              {label: 'IVA Comisión',value: this.datosSalida.totalIva.amount,moneda: this.datosSalida.totalIva.currency ? this.formatearMoneda(this.datosSalida.totalIva.currency.id) : ''},
              {label: 'Importe neto anticipo',value: this.datosSalida.totalNetAmount.amount,moneda: this.datosSalida.totalNetAmount.currency ? this.formatearMoneda(this.datosSalida.totalNetAmount.currency.id) : ''}];
              this.confirmacion='OK';
              this.beforeSubmit = false;
            })
            .catch(function (error) {
              if(error.response){ 
                if(error.response.status == 400) {
                  if(error.response.data.result.errors[0].errorCode == "096H") {
                    ventana.datosFirma = error.response.data.result.errors[0].info;
                    ventana.beforeSubmit = false;
                  }else{
                    if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                      ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                    }else{ //si no, por defecto
                      ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                    }
                    ventana.confirmacion='KO';
                    ventana.beforeSubmit=true;
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: 'smooth'
                    });
                  }
                }else{
                  if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                    ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                  }else{ //si no, por defecto
                    ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                  }
                  ventana.confirmacion='KO';
                  ventana.beforeSubmit=true;
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                  });
                }
              }
            })
            .then(function () {
              loader.hide();
            });
          }
      }
    }
}
</script>